import React from "react";
import { useQuery } from "@apollo/client";
import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { GET_IPS_DEFICIENCIES } from "../../../queries/archiveQrys/IpsDeficienciesQrys";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";

const IpsDeficienciesTable = () => {
  const columns = [
    {
      Header: "Code",
      accessor: "typeCode",
      disableFilters: true
    },
    {
      Header: "Description",
      accessor: "typeDesc",
      disableFilters: true
    },
    {
      Header: "Point",
      accessor: "point",
      disableFilters: true
    },
    {
      Header: "Max Point",
      accessor: "maxPoint",
      disableFilters: true
    },
    {
      Header: "Rule Name",
      accessor: "ruleName",
      disableFilters: true
    },
    {
      Header: "Severity",
      accessor: "severity",
      disableFilters: true
    },
    {
      Header: "Days",
      accessor: "daysToCorrect",
      disableFilters: true
    }
  ];

  const { loading, data } = useQuery(GET_IPS_DEFICIENCIES);
  if (loading) return <SkeletonLoader width='100%' />;

  return (
    <DtsReactTable
      data={data.getPublicIpsDeficiencyPoints}
      columns={columns}
      headerColor='grey'
      cypressid='ipsDeficiencyTable'
    />
  );
};

export default IpsDeficienciesTable;
